import { EntypoBowl } from "react-entypo-icons";
import React from "react";
import { toast } from "react-toastify";
import Logo from "../images/star_buckss.png";
import NoFoodImg from "../images/empty_order.png";

export const Language = "es";
export const API_URL = process.env.REACT_APP_API_URL;
export const ROUTE_PREFIX = process.env.REACT_APP_ROUTE_PREFIX || ""
export const KLAP_SCRIPT_URL = process.env.REACT_APP_KLAP_SCRIPT_URL

export const LIMIT = 5;
export const BARCODE_XML_TEMPLATE_ID = "5f5c907f49566761be9afc02";
export const BILL_TEMPLATE_ID = "5faaa79bd39ed300067e7def";
export const HEADER_ORIGIN_KEY = "p-source";
export const HEADER_ORIGIN = "portal";
export const DISPATCH_TYPE = 2;

export const emailRegxPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

// modules
export const RESTAURANT = "Restaurant";

// Restaurant user roles
export const RESTAURANT_ADMIN = "restaurant_admin";
export const RESTAURANT_WAITER = "restaurant_waiter";
export const RESTAURANT_CHEF = "restaurant_chef";

// Barcode values
export const BARCODE_RESPONSE_HEIGHT = 306;
export const BARCODE_RESPONSE_WIDTH = 297;
export const BARCODE_WIDTH = 300;
export const BARCODE_P_LEFT = 50;
export const BARCODE_P_WIDTH = 550;

// local storage
export const ADDED_FOOD_ITEMS = "ADDED_FOOD_ITEMS";
export const ORG_ID = "organisationId";
export const ORG_INFO = "organisationInfo";
export const TABLE_ID = "tableID";
export const LOGO_URL = "logoImg";
export const BG_URL = "bgImg";
export const PRIMARY_COLOR = "primaryColor";
export const SECONDARY_COLOR = "secondaryColor";
export const CUSTOMER_ID = "customerId";
export const CUSTOMER_EMAIL = "customerEmail";
export const LOGIN_VALUE = "loginValue";
export const INITIALPAGE = "initialPage";
export const IS_TIP_ENABLED = "isTipEnabled"
export const KLAP_ORDER_ID = "klapOrderId"
export const REFERENCE_ORDER_ID = "referenceOrderId"


// images
export const EMPTY_DATA_ILLUSTRATER = NoFoodImg;

// Routes
export const FOOD_SELECTION_ROUTE = "food-selection";
export const LOGIN_ROUTE = "login";

// Toast status enum
export const ToastStatus = Object.freeze({
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
  SUCCESS: "success",
});

// Toast position enum
export const ToastPosition = Object.freeze({
  // top-right' | 'top-center' | 'top-left' | 'bottom-right' | 'bottom-center' | 'bottom-left
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  TOP_LEFT: "top-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center",
  BOTTOM_LEFT: "bottom-left",
});

// Toast display common function
export const displayToast = (type, message, position = ToastPosition.TOP_RIGHT) => {
  const toastConfig = {
    position: position,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  switch (type) {
    case ToastStatus.ERROR:
      toast.error(message, toastConfig);
      break;
    case ToastStatus.WARNING:
      toast.warning(message, toastConfig);
      break;
    case ToastStatus.INFO:
      toast.info(message, toastConfig);
      break;
    case ToastStatus.SUCCESS:
      toast.success(message, toastConfig);
      break;
  }
};

export const updateNumber = (value) => {
  value = value.toString();
  let status = value.includes("-");
  if (status === false) {
    value =
      value.substr(0, value.length - 1) + "-" + value.substr(value.length - 1);
  }
  return value;
};

export const roundWithTwoDecimals = (value) => {
  console.log(
    "🚀 ~ file: Calculator.js ~ line 217 ~ Calculator ~ value",
    value
  );
  if (value) {
    console.log("value type is", typeof value);
    if (typeof value === "string") {
      console.log("value before assign", value);
      value = value.replace("$", "");
      console.log("value before 2nd assign", value);
      value = value.replace(/\./g, "");
      console.log("value after assign", value);
    }
    console.log("before return value", Math.round(value * 100) / 100);
    return Math.round(value * 100) / 100;
  }
};

export const formateNumber = (value, onlyValue) => {
  if (value.toString().includes(".")) {
    value = value.toString().replace(".", ",");
  }
  let formattedValue = "";
  if (!onlyValue) {
    formattedValue += "$";
  }
  formattedValue += value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return formattedValue;
};

export const getBarcodeValuesFromResponse = (apiResponse) => {
  let responseHeight = BARCODE_RESPONSE_HEIGHT;
  let responseWidth = BARCODE_RESPONSE_WIDTH;
  let pLeft = BARCODE_P_LEFT;
  let pWidth = BARCODE_P_WIDTH;
  let barcodeImage = "";

  if (apiResponse["barcode-image-height"])
    responseHeight = apiResponse["barcode-image-height"];
  if (apiResponse["barcode-image-width"])
    responseWidth = apiResponse["barcode-image-width"];
  if (apiResponse["barcode-p-pLeft"]) pLeft = apiResponse["barcode-p-pLeft"];
  if (apiResponse["barcode-p-pWidth"]) pWidth = apiResponse["barcode-p-pWidth"];
  if (apiResponse["barcode"]) barcodeImage = apiResponse["barcode"];

  return {
    responseHeight,
    responseWidth,
    pLeft,
    pWidth,
    barcodeImage,
  };
};

export const getBarcodeImageHeight = (
  barcodeWidth,
  responseHeight,
  responseWidth
) => {
  let barcodeHeight = (barcodeWidth * responseHeight) / responseWidth;
  barcodeHeight = Math.round(barcodeHeight);
  return barcodeHeight;
};

export const getItemMainPrice = (data, type, withoutTax) => {
  let mainPriceWithoutTax = withoutTax ? data.mainPrice : data.mainPrice / 1.19;
  mainPriceWithoutTax = roundWithTwoDecimals(mainPriceWithoutTax);
  let itemMainPrice = 0;
  if (type === 4) {
    itemMainPrice = Math.round(data.mainPrice);
  } else if (type === 1) {
    itemMainPrice = mainPriceWithoutTax;
  } else {
    itemMainPrice = data.mainPrice;
  }
  return formateNumber(itemMainPrice);
};

export const getTotalPriceOfItem = (data, type, withoutTax) => {
  let mainPriceWithoutTax = withoutTax ? data.mainPrice : data.mainPrice / 1.19;
  mainPriceWithoutTax = roundWithTwoDecimals(mainPriceWithoutTax);
  let quantity = data.quantity.toString().replace(/\,/g, ".");
  quantity = parseFloat(quantity);

  let total = quantity * data.mainPrice;
  let totalPriceWithoutTax = mainPriceWithoutTax * quantity;

  let totalPrice = 0;
  if (type === 2 || type === 4 || type === 6) {
    totalPrice = Math.round(data.FAWT);
  } else if (type === 5) {
    totalPrice = parseFloat(data.FAWT);
  } else if (type === 1) {
    totalPrice = Math.round(totalPriceWithoutTax);
  } else {
    totalPrice = total;
  }
  return formateNumber(totalPrice);
};

export const getKOTStatusIcon = (status, iconSize, iconColor) => {
  let name = "hourglass-empty";
  if (status === "draft" || status === "in_queue") {
    name = "hourglass_empty";
  } else if (status === "prepared" || status === "cooking") {
    name = "bowl";
  } else if (status === "served" || status === "done") {
    name = "dinner_dining";
  }

  if (name === "bowl") {
    return (
      <EntypoBowl
        style={{ fontSize: iconSize, color: iconColor, fontWeight: 400 }}
      />
    );
  } else {
    return (
      <i
        class="material-icons"
        style={{ fontSize: iconSize, color: iconColor, fontWeight: 400 }}
      >
        {name}
      </i>
    );
  }
};

export const getDataArrayForRestaurant = (foodItems) => {
  let dataArray = [];

  const mergedFoodItems = Object.values(
    foodItems.reduce((acc, curr) => {
      if (!acc[curr.itemID]) {
        acc[curr.itemID] = { ...curr };
      } else {
        acc[curr.itemID].quantity = String(
          Number(acc[curr.itemID].quantity) + Number(curr.quantity)
        );
        acc[curr.itemID].totalPrice =
          Number(acc[curr.itemID].totalPrice) + Number(curr.totalPrice);
      }
      return acc;
    }, {})
  );

  console.log("mergedDuplicate food items", mergedFoodItems);

  const formattedFoodItems = mergedFoodItems.map(
    ({ itemCode, itemID, itemName, price, quantity, totalPrice }) => ({
      itemCode,
      itemID,
      itemName,
      price,
      quantity,
      totalPrice,
    })
  );

  console.log("formatted food items", formattedFoodItems);

  formattedFoodItems.map((item, index) => {
    const taxAmount = parseInt(item.price) * 0.19;
    const quantity = parseInt(item.quantity);
    const totalTaxAmount = taxAmount * quantity;
    const priceWithTax = parseInt(item.price) + taxAmount;
    const totalPriceWithTax = item.totalPrice + totalTaxAmount;
    const singleObj = {
      FAWT: item.totalPrice ? item.totalPrice : 0,
      discount: 0,
      iva: 0, // items without tax code
      // "iva": totalTaxAmount, // items with tax code commented at 2024-08-02
      mainPriceWithTax: item.price ? item.price : 0, // items without tax code
      // "mainPriceWithTax": priceWithTax.toString() ?? 0, // items with tax code commented at 2024-08-02
      percent: true,
      tax: true,
      totalDiscount: 0,
      itemType: "",
      itemCode: item.itemCode ? item.itemCode : "",
      description: item.itemName ? item.itemName : "",
      quantity: item.quantity ? item.quantity : 0,
      total: item.totalPrice ? item.totalPrice : 0, // items without tax code
      // "total": totalPriceWithTax ?? 0, // items with tax code commented at 2024-08-02
      mainPrice: item.price ? item.price : 0, // items without tax code
      // "mainPrice": priceWithTax.toString() ?? 0, // items with tax code commented at 2024-08-02
    };
    dataArray.push(singleObj);
  });

  return dataArray;
};

export const hasOrganizationRestaurantPermission = () => {
  let hasRestaurantPermission = false;
  let organizationData = JSON.parse(localStorage.getItem("organisation_info"));
  if (
    organizationData !== undefined &&
    organizationData !== null &&
    organizationData["data"]["restaurantModule"] !== undefined &&
    organizationData["data"]["restaurantModule"] !== null
  ) {
    hasRestaurantPermission = organizationData["data"]["restaurantModule"];
  }
  return hasRestaurantPermission;
};

export const compareDates = (previousDate, currentDate) => {
  if (!previousDate || !currentDate) return false;
  // console.log('previousDate', previousDate)
  const prev = new Date(previousDate);
  const curr = new Date(currentDate);
  // console.log('previous date', prev);
  // console.log('current date', curr);

  if (curr > prev) {
    return true;
  } else {
    return false;
  }
};

export const setFoodDataInStorage = (foodItems) => {
  const data = JSON.stringify(foodItems);
  localStorage.setItem(ADDED_FOOD_ITEMS, data);
};

export const getFoodDataFromStorage = () => {
  return localStorage.getItem(ADDED_FOOD_ITEMS);
};

export const setTipValueInStorage = (value) => {
  localStorage.setItem(IS_TIP_ENABLED, value);
};

export const getTipValueFromStorage = () => {
  let tipValue = false;
  const value = localStorage.getItem(IS_TIP_ENABLED);
  if (value && typeof value === "string") {
    if (value === "true") {
      tipValue = true;
    }
  }
  return tipValue;
};

export const setKlapOrderIdInStorage = (value) => {
  localStorage.setItem(KLAP_ORDER_ID, value);
};

export const getKlapOrderIdFromStorage = () => {
  return localStorage.getItem(KLAP_ORDER_ID);
};

export const setReferenceOrderIdInStorage = (value) => {
  localStorage.setItem(REFERENCE_ORDER_ID, value);
};

export const getReferenceOrderIdFromStorage = () => {
  return localStorage.getItem(REFERENCE_ORDER_ID);
};

export const clearFoodDataFromStorage = () => {
  localStorage.removeItem(IS_TIP_ENABLED);
  localStorage.removeItem(KLAP_ORDER_ID);
  localStorage.removeItem(REFERENCE_ORDER_ID);
  localStorage.removeItem(ADDED_FOOD_ITEMS);
};

export const navigatePage = (endpoint) => {
  window.location.replace(endpoint);
};

export const getPlatform = () => {
  let platform = "";
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(ua)) {
    platform = "Android";
  } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    platform = "iOS";
  } else {
    platform = "Web";
  }
  return platform;
};

export const getFormattedDate = (date) => {
  const formattedDate = new Date(date).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return formattedDate;
};

export const getFormattedDateTime = (dateString) => {
  const date = new Date(dateString);

  const options = {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const formatted = new Intl.DateTimeFormat("en-US", options).format(date);

  return formatted;
};

export const getLogoUrl = () => {
  return localStorage.getItem(LOGO_URL);
};

export const getBgImageUrl = () => {
  // return Logo;
  return localStorage.getItem(BG_URL);
};

export const getPrimaryColor = () => {
  // return Logo;
  return localStorage.getItem(PRIMARY_COLOR);
};

export const getSecondaryColor = () => {
  // return Logo;
  return localStorage.getItem(SECONDARY_COLOR);
};

export const getTotalPriceOfFoodItem = (foodItemPrice, foodItemQty) => {
  const price = foodItemPrice ? parseFloat(foodItemPrice) : 0;
  const qty = foodItemQty ? parseFloat(foodItemQty) : 0;
  return formateNumber(qty < 1 ? price : price * qty);
};

export const getOrganisationId = () => {
  return localStorage.getItem(ORG_ID);
};

export const setOrganisationId = (organisationId) => {
  return localStorage.setItem(ORG_ID, organisationId);
};

export const setLoginValueInStorage = (value) => {
  return localStorage.setItem(LOGIN_VALUE, value);
}

export const getLoginValueFromStorage = () => {
  const loginValue = localStorage.getItem(LOGIN_VALUE);
  let loginEnabled = false;
  if (loginValue && loginValue === "true") {
    loginEnabled = true;
  }
  return loginEnabled;
}

export const setInitialPageInStorage = (page) => {
  return localStorage.setItem(INITIALPAGE, page);
}

export const getInitialPageFromStorage = () => {
  return localStorage.getItem(INITIALPAGE);
}

export const getOrganisationInfo = () => {
  const orgInfo = localStorage.getItem(ORG_INFO)
  const parsedData = JSON.parse(orgInfo)
  return parsedData;
}